import './App.css';
import "./assets/css/style.css";
import { FinalGoogleAds } from './components/landingPage';

function App() {
  return (
    <div className="App">
      <FinalGoogleAds />
    </div>
  );
}

export default App;
